import { render, staticRenderFns } from "./DashboardBalance.vue?vue&type=template&id=07a701cb&scoped=true&"
import script from "./DashboardBalance.vue?vue&type=script&lang=ts&"
export * from "./DashboardBalance.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardBalance.vue?vue&type=style&index=0&id=07a701cb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07a701cb",
  null
  
)

export default component.exports